export const GET_INTENT_UTTERANCE_LIST_REQUEST =
  'GET_INTENT_UTTERANCE_LIST_REQUEST';
export const GET_INTENT_UTTERANCE_LIST_SUCCESS =
  'GET_INTENT_UTTERANCE_LIST_SUCCESS';
export const GET_INTENT_UTTERANCE_LIST_ERROR =
  'GET_INTENT_UTTERANCE_LIST_ERROR';
export const ADD_INTENT_UTTERANCE_REQUEST = 'ADD_INTENT_UTTERANCE_REQUEST';
export const ADD_INTENT_UTTERANCE_SUCCESS = 'ADD_INTENT_UTTERANCE_SUCCESS';
export const ADD_INTENT_UTTERANCE_ERROR = 'ADD_INTENT_UTTERANCE_ERROR';
export const UPDATE_INTENT_UTTERANCE_REQUEST =
  'UPDATE_INTENT_UTTERANCE_REQUEST';
export const UPDATE_INTENT_UTTERANCE_SUCCESS =
  'UPDATE_INTENT_UTTERANCE_SUCCESS';
export const UPDATE_INTENT_UTTERANCE_ERROR = 'UPDATE_INTENT_UTTERANCE_ERROR';
export const UPDATE_INTENT_UTTERANCES_REQUEST =
  'UPDATE_INTENT_UTTERANCES_REQUEST';
export const UPDATE_INTENT_UTTERANCES_SUCCESS =
  'UPDATE_INTENT_UTTERANCES_SUCCESS';
export const UPDATE_INTENT_UTTERANCES_ERROR = 'UPDATE_INTENT_UTTERANCES_ERROR';
export const DELETE_INTENT_UTTERANCE_REQUEST =
  'DELETE_INTENT_UTTERANCE_REQUEST';
export const DELETE_INTENT_UTTERANCE_SUCCESS =
  'DELETE_INTENT_UTTERANCE_SUCCESS';
export const DELETE_INTENT_UTTERANCE_ERROR = 'DELETE_INTENT_UTTERANCE_ERROR';
